import dynamic from "next/dynamic";
import React, { useState, useEffect, useRef } from "react";
import imageUrlBuilder from "@sanity/image-url";
import Image from "next/image";
const PostCard = dynamic(() => import("../../components/PostCard"));
const Grid = dynamic(() => import("@mui/material/Grid"));

import { client } from "../../../lib/client";
import { motion } from "framer-motion";
import UseAnimationIos from "../api/UseAnimationIos";
import { imageScale } from "@/utils/motion";

import Head from "next/head";
import styles from "@/styles/blogs.module.css";

const SeoComponents = () => (
  <Head>
    <meta name="robots" content="index, follow" />
    <link rel="canonical" href="https://techcelerant.com/blogs" />
    <title>Blogs | Techcelerant</title>
    <meta
      name="description"
      content="Keep up to date with the latest tech insights, business guidelines and trending news articles, and stay tech-savvy!"
    />
    <link rel="apple-touch-icon" href="apple-touch-icon.png" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <link rel="icon" href="/favicon.ico" />
  </Head>
);

const Blog = ({ posts }) => {
  const [mappedPosts, setMappedPosts] = useState([]);
  useEffect(() => {
    if (posts?.length) {
      const imageBuilder = imageUrlBuilder(client);
      setMappedPosts(
        posts.map((post) => ({
          ...post,
          mainImage: imageBuilder?.image(post?.mainImage).url(),
          author_Image: imageBuilder
            ?.image(post?.author.image)
            .width(1000)
            .height(1000)
            .url(),
        })),
      );
    } else {
      setMappedPosts([]);
    }
  }, [posts]);

  const [onScreen, setOnScreen] = useState(false);
  const ref = useRef();
  UseAnimationIos(ref, setOnScreen);
  const animation = onScreen
    ? imageScale(1.5).animate
    : imageScale(0.5).initial;

  return (
    <>
      <SeoComponents />

      <div
        className={` ${styles["blogs-main-container"]} min-h-[40vh] pb-[6rem] sm:pb-[1rem] `}
      >
        <div className="min-w-[50%] flex flex-col justify-center items-center">
          <h1 className="text-center sm:text-start text-white text-[2rem] sm:text-[4rem] ">
            Discover What&apos;s <br /> New With
          </h1>
          <span className="flex items-center justify-center bg-white px-2 rounded-xl sm:-ml-[3.5rem]">
            <h3 className={styles["blogs-main-container_div_h2"]}>
              Techcelerant
            </h3>
          </span>
        </div>

        <div className="min-w-[50%] z-[-1] hidden sm:block">
          <Image
            width={1000}
            height={1000}
            quality={100}
            alt="vector image with blogs text for blog page"
            src="https://imagedelivery.net/9otR1sBY_9ZFhJikSNrX6g/996dd86d-9bdd-403b-6838-03533d339d00/1920x1080"
          />
        </div>
      </div>

      <div className="bg-white" ref={ref}>
        <div className=" sm:pt-40  h-auto z-20 bg-white pb-[5rem] sm:py-[5rem]">
          <motion.div
            initial={imageScale(0.5).initial}
            animate={animation}
            className="px-2 sm:px-0 max-w-[85rem] m-auto"
          >
            <Grid container spacing={2}>
              <Grid item xs={12} lg={6} md={12}>
                {mappedPosts &&
                  mappedPosts.length &&
                  mappedPosts.map((post, index) => (
                    <PostCard data={post} key={index} />
                  ))}
              </Grid>
              <Grid
                sx={{ display: "flex", justifyContent: "center" }}
                item
                xs={12}
                lg={6}
                md={12}
              >
                <div>
                  <h3 className="text-black font-bold py-1">
                    Discover more of what matters to you
                  </h3>
                  <div className="py-[1rem]">
                    <button className="text-gray-700 text-[14px] bg-gray-200 px-2 py-2 rounded-full mx-2">
                      Programming
                    </button>
                    <button className="text-gray-700 text-[14px] bg-gray-200 px-2 py-2  rounded-full mx-2">
                      Data Science
                    </button>
                  </div>
                  <div className="py-[1rem]">
                    <button className="text-gray-700 text-[14px] bg-gray-200 px-2 py-2 rounded-full mx-2">
                      Technology
                    </button>

                    <button className="text-gray-700 text-[14px] bg-gray-200 px-2 py-2  rounded-full mx-2">
                      Self Improvement
                    </button>
                  </div>
                  <div className="py-[1rem]">
                    <button className="text-gray-700 text-[14px] bg-gray-200 px-2 py-2 rounded-full mx-2">
                      Writing
                    </button>
                    <button className="text-gray-700 text-[14px] bg-gray-200 px-2 py-2 rounded-full mx-2">
                      Machine Learning
                    </button>
                  </div>
                </div>
              </Grid>
            </Grid>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export const getStaticProps = async () => {
  const productsQuery = `*[_type == "post"] | order(publishedAt desc) {
    ...,
    author-> {
      _id,
      name,
      image,
      // add other fields you want from the author here
    }
  }`;

  const posts = await client.fetch(productsQuery);

  return {
    props: { posts },
    revalidate: 1, // add this line to re-fetch data at most once per second
  };
};
export default Blog;
